
import SelectorDay from "./SelectorDay";

export default function Selector({ isDesktop, days, selectedDay, onSelectDay }) {
	const selectedDayId = selectedDay && (selectedDay.id || null);

	function handleSelectDay(dayId) {
		onSelectDay(dayId);
	}

	return (
		<div className="w-full">
			<div className="flex flex-row max-w-full overflow-x-auto">
				{days.map(day => (
					<div key={day.id} className="p-[5px]">
						<SelectorDay key={day.id} isDesktop={isDesktop} day={day} isSelected={day.id === selectedDayId} onClick={() => handleSelectDay(day.id)} />
					</div>
				))}
			</div>
		</div>
	)
}
